import addDays from 'date-fns/esm/addDays';
import differenceInDays from 'date-fns/esm/differenceInDays';
import differenceInMilliseconds from 'date-fns/esm/differenceInMilliseconds';
import endOfDay from 'date-fns/esm/endOfDay';
import format from 'date-fns/esm/format';
import startOfDay from 'date-fns/esm/startOfDay';

export const STANDARD_DATE = 'MM-dd-yyyy';
export const DEFAULT_DATE_FORMAT = 'MMMM d, yyyy';
export const DATE_WITH_SUFFIX = 'MMMM do, yyyy';
export const DEFAULT_DATETIME_FORMAT = `${DEFAULT_DATE_FORMAT} hh:mm a`;
export const DATETIME_SUFFIX = `${DATE_WITH_SUFFIX} hh:mm a`;

export const roundToNearestMinute = (date: Date, minutes: number): Date => {
  const minutesInMs = 1000 * 60 * minutes;
  return new Date(Math.round(date.getTime() / minutesInMs) * minutesInMs);
};

export const formatDateString = (date: Date | string | number, dateFormat: string = DEFAULT_DATE_FORMAT): string => {
  const parsedDate = new Date(date);
  return format(parsedDate, dateFormat);
};

export const getDatesFromRange = (range: Interval): Date[] => {
  const diffInDays = differenceInDays(startOfDay(range.end), startOfDay(range.start));
  let day = range.start;
  let days = [new Date(day)];
  for (let i = 0; i < diffInDays; i++) {
    day = addDays(day, 1);
    days = [...days, new Date(day)];
  }
  return days;
};

export const getMsToMidnight = (date: Date = new Date()): number =>
  differenceInMilliseconds(endOfDay(new Date()), new Date());
